import React, { useState, useEffect } from 'react';
import { Container, Grid, Typography, Divider } from '@mui/material';
import useStore from 'src/store/cns';
import SelectToken from '../widget/SelectToken';
import { checkAllowance } from 'src/utils/contracts/token';
import { ACTIVE_DEPLOYMENT } from 'src/utils/contracts/common';
import RegistrarDeployment from '../../contracts/deployments/Registrar.json';
import { getProvider } from 'src/utils/wallet';
import { balanceOf } from 'src/utils/contracts/token';
import { ethers } from 'ethers';
import Allowance from '../payment/Allowance';
import Renewal from '../payment/Renewal';
import Cost from '../payment/Cost';

interface Props {
  onValueChange: (expirationDate: string, renewalPeriod: number) => void;
  domain: Domain;
  expirationDate: string;
  wallet: ethers.JsonRpcSigner;
}

const Expiration: React.FC<Props> = ({
  onValueChange,
  domain,
  expirationDate,
  wallet,
}) => {
  const tokens = useStore(state => state.tokens);
  const [selectedToken, setSelectedToken] = useState<Token>(tokens[0]);

  const [renewalCost, setRenewalCost] = useState(
    Number(selectedToken.basePrice),
  );
  const [renewalPeriod, setRenewalPeriod] = useState(1);
  const [allowance, setAllowance] = useState(0);
  const [balance, setBalance] = useState('0');

  const handleChange = (token: Token) => {
    setSelectedToken(token);
  };

  const updateCostAndYears = (cost: number, years: number) => {
    setRenewalCost(cost);
    setRenewalPeriod(years);
  };

  const handleRenewal = (renewalPeriod: number) => {
    if (
      selectedToken.tokenAddress !==
      '0x0000000000000000000000000000000000000000'
    ) {
      setAllowance(allowance - renewalCost);
    }
    onValueChange(expirationDate, renewalPeriod);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (
        selectedToken.tokenAddress !==
        '0x0000000000000000000000000000000000000000'
      ) {
        const newBalance = await balanceOf(selectedToken.tokenAddress);
        setBalance(ethers.formatEther(newBalance));
        setAllowance(
          await checkAllowance(
            RegistrarDeployment[ACTIVE_DEPLOYMENT].address,
            selectedToken.tokenAddress,
          ),
        );
      } else if (
        selectedToken.tokenAddress ===
        '0x0000000000000000000000000000000000000000'
      ) {
        const provider = getProvider();
        const newBalance = await provider.getBalance(wallet.address);
        setBalance(ethers.formatEther(newBalance));
      }
    };
    fetchData();
  }, [selectedToken]);

  return (
    <Container maxWidth="sm">
      <Typography variant="h5" textAlign="center">
        Current Expiraition Date:{' '}
        <span style={{ color: '#66C9E8' }}>{expirationDate}</span>
      </Typography>
      {domain.name.split('.').length === 2 ? (
        <Grid container mt={1} spacing={2} rowSpacing={4} alignItems="center">
          <Grid item xs={6}>
            <Typography>Add Years</Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <Cost
              onValueChange={updateCostAndYears}
              expirationDate={expirationDate}
              token={selectedToken}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography>ERC-20 Token</Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <SelectToken onValueChange={handleChange} />
          </Grid>
          <Grid item xs={8}>
            <Typography>Current Balance</Typography>
          </Grid>
          <Grid item xs={4} textAlign="right">
            {balance} {selectedToken.symbol}
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="start">
            <Typography>Renewal Cost</Typography>
          </Grid>
          <Grid item xs={6} textAlign="right">
            <Typography>
              - {renewalCost} {selectedToken.symbol}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          {Number(balance) <= renewalCost ? (
            <Grid item xs={12} textAlign="center">
              <Typography>
                Not enough {selectedToken.name} to renew the domain.
              </Typography>
            </Grid>
          ) : (
            <>
              <Grid item xs={8}>
                <Typography>After Purchase Balance</Typography>
              </Grid>
              <Grid item xs={4} textAlign="right">
                {Number(balance) - renewalCost} {selectedToken.symbol}
              </Grid>

              <Grid item xs={12} display="flex" justifyContent="center">
                {allowance < renewalCost &&
                selectedToken.tokenAddress !==
                  '0x0000000000000000000000000000000000000000' ? (
                  <Allowance
                    cost={renewalCost}
                    token={selectedToken}
                    onValueChange={setAllowance}
                  />
                ) : (
                  <Renewal
                    label={
                      domain.name.split('.')[domain.name.split('.').length - 2]
                    }
                    renewalPeriod={renewalPeriod}
                    token={selectedToken}
                    renewalCost={renewalCost}
                    onValueChange={handleRenewal}
                  />
                )}
              </Grid>
              {selectedToken.tokenAddress !==
                '0x0000000000000000000000000000000000000000' &&
              allowance < renewalCost ? (
                <>
                  <Grid item xs={12} textAlign="center">
                    <Typography variant="caption">
                      You need to approve the Registrar to spend ERC-20 tokens
                      on your behalf.
                    </Typography>
                  </Grid>
                </>
              ) : null}
            </>
          )}
        </Grid>
      ) : (
        <Typography variant="body1" textAlign="center" mt={5}>
          Visit{' '}
          {domain.name.split('.')[domain.name.split('.').length - 2] + '.cam'}{' '}
          to extend expiration date.
        </Typography>
      )}
    </Container>
  );
};

export default Expiration;
